import React from 'react';

const IconProofOfDelivery = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        x='1.5'
        y='2.5'
        width='13'
        height='11'
        rx='2'
        stroke='#172751'
        strokeWidth='1.5'
      />
      <circle cx='5.5' cy='6' r='1.25' fill='#172751' />
      <path
        d='M2.5 12l3.4-3.4a1 1 0 0 1 1.4 0L9.5 10.8l1.6-1.6a1 1 0 0 1 1.4 0l1 1'
        stroke='#172751'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default IconProofOfDelivery;
